/**
 * Frontend Dropdown Manager
 * Reemplaza dropit.js con implementación nativa moderna
 */

export class FrontendDropdown {
    constructor(selector = '.ddm') {
        this.selector = selector;
        this.dropdowns = [];
        this.isInitialized = false;
        this.init();
    }

    init() {
        if (this.isInitialized) return;
        
        this.dropdowns = document.querySelectorAll(this.selector);
        
        if (this.dropdowns.length === 0) {
            console.log('No se encontraron dropdowns con selector:', this.selector);
            return;
        }

        this.setupDropdowns();
        this.setupGlobalEvents();
        this.isInitialized = true;
        
        console.log(`Frontend Dropdowns inicializados: ${this.dropdowns.length} elementos`);
    }

    setupDropdowns() {
        this.dropdowns.forEach(dropdown => {
            this.setupSingleDropdown(dropdown);
        });
    }

    setupSingleDropdown(dropdown) {
        // Agregar clase de identificación
        dropdown.classList.add('dropit-modern');
        
        // Buscar elementos trigger que tienen submenu
        const triggers = dropdown.querySelectorAll('li:has(ul) > a, li > a:has(+ ul)');
        
        triggers.forEach(trigger => {
            const parentLi = trigger.closest('li');
            const submenu = parentLi.querySelector('ul');
            
            if (!submenu) return;
            
            // Marcar como trigger y submenu
            parentLi.classList.add('dropit-trigger');
            submenu.classList.add('dropit-submenu');
            
            // Ocultar submenu inicialmente
            submenu.style.display = 'none';
            
            // Configurar eventos
            trigger.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                this.toggleDropdown(parentLi);
            });
        });
    }

    toggleDropdown(triggerElement) {
        const isCurrentlyOpen = triggerElement.classList.contains('dropit-open');
        
        // Cerrar todos los dropdowns primero
        this.closeAllDropdowns();
        
        // Si no estaba abierto, abrirlo
        if (!isCurrentlyOpen) {
            this.openDropdown(triggerElement);
        }
    }

    openDropdown(triggerElement) {
        const submenu = triggerElement.querySelector('.dropit-submenu');
        if (!submenu) return;
        
        triggerElement.classList.add('dropit-open');
        submenu.style.display = 'block';
        
        // Trigger custom event
        triggerElement.dispatchEvent(new CustomEvent('dropdown:opened', {
            detail: { element: triggerElement }
        }));
    }

    closeDropdown(triggerElement) {
        const submenu = triggerElement.querySelector('.dropit-submenu');
        if (!submenu) return;
        
        triggerElement.classList.remove('dropit-open');
        submenu.style.display = 'none';
        
        // Trigger custom event
        triggerElement.dispatchEvent(new CustomEvent('dropdown:closed', {
            detail: { element: triggerElement }
        }));
    }

    closeAllDropdowns() {
        const openDropdowns = document.querySelectorAll('.dropit-open');
        openDropdowns.forEach(dropdown => {
            this.closeDropdown(dropdown);
        });
    }

    setupGlobalEvents() {
        // Cerrar dropdowns al hacer clic fuera
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.ddm')) {
                this.closeAllDropdowns();
            }
        });

        // Cerrar dropdowns al presionar ESC
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.closeAllDropdowns();
            }
        });
    }

    /**
     * Método para refrescar dropdowns dinámicos
     */
    refresh() {
        this.isInitialized = false;
        this.init();
    }

    /**
     * Método para destruir la instancia
     */
    destroy() {
        this.closeAllDropdowns();
        
        // Remover event listeners (si fuera necesario guardar referencias)
        this.dropdowns.forEach(dropdown => {
            dropdown.classList.remove('dropit-modern');
            const triggers = dropdown.querySelectorAll('.dropit-trigger');
            triggers.forEach(trigger => {
                trigger.classList.remove('dropit-trigger', 'dropit-open');
                const submenu = trigger.querySelector('.dropit-submenu');
                if (submenu) {
                    submenu.classList.remove('dropit-submenu');
                    submenu.style.display = '';
                }
            });
        });
        
        this.isInitialized = false;
    }
}
